module.exports = __webpack_public_path__ + "media/images/hotel_header-8dc9fbdc042c4eeee8ddaec08bdf109e.png";